// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1VQ8Q","left":"InfoRow_left__7wT92"};